<template>
  <div class="step-pane fade flex flex-wrap" :class="{show: selected, hidden: !selected}" :id="'sptes-' + idStep">
    <slot v-if="hasSlot('content')" :name="'content'" />
    <template v-else>
      {{ content }}
    </template>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    idStep: {
      type: String,
      default() {
        return `${uuid()}`
      },
    },
    title: {
      type: String,
      default() {
        return `STEP`
      },
    },
    content: {
      type: String,
      default() {
        return `CONTENT`
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    
  },
  methods: {
    hasSlot (name = 'default') {
      return !!this.$slots[ name ];
    }
  },
}
</script>
